var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsCount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "179.71 77.754 32.6 32.602",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 209.039 102.256 C 209.039 103.36 208.154 104.341 206.891 104.341 L 181.858 104.341 C 180.594 104.341 179.71 103.36 179.71 102.256 C 179.71 101.766 179.836 101.275 180.215 100.907 C 181.479 99.559 183.881 97.596 183.881 91.097 C 183.881 86.191 187.421 82.143 192.225 81.285 L 192.225 79.936 C 192.351 78.709 193.236 77.851 194.374 77.851 C 195.513 77.851 196.524 78.709 196.524 79.936 L 196.524 81.285 C 201.328 82.266 204.868 86.191 204.868 91.097 C 204.868 97.596 207.27 99.559 208.533 100.907 C 208.914 101.275 209.039 101.766 209.039 102.256 Z M 204.614 101.275 C 203.224 99.559 201.707 96.492 201.707 91.097 C 201.707 87.172 198.42 83.983 194.374 83.983 C 190.329 83.983 187.042 87.172 187.042 91.097 C 187.042 96.492 185.525 99.436 184.134 101.275 L 204.614 101.275 Z M 190.203 106.304 L 198.547 106.304 C 198.547 108.511 196.649 110.35 194.374 110.35 C 192.099 110.473 190.203 108.634 190.203 106.304 Z",
    fill: "#626262",
    style: {}
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 201.369 87.114 C 201.388 87.133 201.405 87.149 201.408 87.149 C 201.411 87.149 201.398 87.133 201.379 87.114 C 201.36 87.094 201.343 87.079 201.34 87.079 C 201.337 87.079 201.35 87.094 201.369 87.114 Z",
    fill: "#A4DCAC"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0, 0, 0)",
      paintOrder: "stroke markers",
      strokeMiterlimit: 1,
      strokeWidth: 0,
      fill: "rgb(58, 202, 121)"
    },
    cx: 203.706,
    cy: 85.368,
    r: 7.339,
    transform: "matrix(1.211363, 0, 0, 1.22155, -43.342434, -17.562216)"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "Jost",
      fontSize: "11.2767px",
      lineHeight: "19.5463px",
      textAnchor: "middle",
      whiteSpace: "pre"
    },
    transform: "matrix(1.299456, -0.006153, 0, 1.064142, -52.312401, -3.531569)",
    x: 196.925,
    y: 89.849
  }, "0")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsCount);
export default __webpack_public_path__ + "static/media/notifications-count.adb0562a8cf9e0bc157a49350175d75e.svg";
export { ForwardRef as ReactComponent };